/** Conversa com o escritório; `?nova=assunto` já abre a mensagem nova com o assunto preenchido. */
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ComPortal } from '../telas/portal/casca';
import { Mensagens } from '../telas/portal/paginas';

export const Route = createFileRoute('/portal/mensagens')({ validateSearch: z.object({ nova: z.string().max(120).optional() }), component: Pagina });
function Pagina() { const { nova } = Route.useSearch(); return <ComPortal>{(d) => <Mensagens d={d} nova={nova} />}</ComPortal>; }
